<template>
  <div>
    <my-head></my-head>
    <div class="newslist minH margin-auto">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">专利超市</span>
      </div>

      <div class="title">专利超市</div>
      <!-- 
      <div class="title1">最新开放许可</div> -->

      <el-row :gutter="50">
        <el-col :span="8" v-for="(item, index) in list" :key="index">
          <div style="cursor: pointer;" @click="toUrl(item.url)">
            <img :src='item.img' class="col_img">
            <p class="col_name">{{ item.name }}</p>
          </div>
        </el-col>

      </el-row>

      <!-- <div class="col flex-between-left" v-for="(item, index) in newslist" :key="index" @click="toNewsD(item.id)">
        <div :style="`width: ${item.imageUrl ? '82%' : '100%'}`">
          <div class="col_title line">
            {{ item.title }}
          </div>

          <div class="col_time" v-show="item.createTime">
            {{ item.createTime | dateYMD }}
          </div>

          <div class="col_content line-two" v-html="item.content"></div>
        </div>
        <img :src="item.imageUrl" alt="" />
      </div> -->


    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import { getRequest } from "../api/api";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      list: [
        { name: '浦东新区专利超市', img: require('../assets/pdxq.png'), url: 'https://www.sinoip.net/front/store/shop?storeId=876a0bf772f14af2bb76001dbbc8cdd1' },
        { name: '松江区专利超市', img: require('../assets/sj.png'), url: 'https://www.sinoip.net/store/shop?storeId=szzl012' },
        { name: '闵知惠', img: require('../assets/mzh.png'), url: 'https://www.sinoip.net/store/shop?storeId=szzl059' },
        { name: '长宁区专利超市', img: require('../assets/cn.png'), url: 'https://www.sinoip.net/store/shop?storeId=szzl045' },
        { name: '黄浦区专利超市', img: require('../assets/hp.png'), url: 'https://www.sinoip.net/store/shop?storeId=szzl060' },
        { name: '嘉定区专利超市', img: require('../assets/jd.png'), url: 'https://www.sinoip.net/store/shop?storeId=szzl039' },
        { name: '长三角浦江知光专利超市', img: require('../assets/csj.png'), url: 'https://www.sinoip.net/store/shop?storeId=szzl023' },
        { name: '静安生物医药专利超市', img: require('../assets/jasw.png'), url: 'https://www.sinoip.net/JinganCSS' },
        { name: '崇明长兴专利超市', img: require('../assets/cm.png'), url: 'https://www.sinoip.net/store/shop?storeId=szzl024' },
        { name: '福州职工创新知识产权超市', img: require('../assets/fz.png'), url: 'https://www.sinoip.net/store/shop?storeId=b2ef0908b97d416caaba7a74f142e1ee' },
        { name: '奉贤区专利超市', img: require('../assets/fxq.png'), url: 'https://www.sinoip.net/front/fengXianStore' },

      ],
    };
  },
  watch: {
    nespage: {
      handler() {
        this.newsList();
      },
      deep: true,
    },
  },
  methods: {
    // 搜索
    toUrl(url) {
      window.open(url, '_blank');
    },

  },
  created() {

  },
};
</script>

<style lang="scss">
.col_img {
  width: 100%
}

.col_name {
  line-height: 25px;
  color: rgba(16, 16, 16, 1);
  font-size: 16px;
  text-align: center;
  font-family: SourceHanSansSC-regular;
  margin: 26px 0;
  font-weight: bold;
}

.el-row {
  margin-bottom: 20px;
  margin-top: 30px;

  &:last-child {
    margin-bottom: 0;
  }
}



.newslist {
  width: 80%;
  padding-bottom: 48px;

  .sou_suo {
    margin-bottom: 20px;
    position: relative;

    .ss_but {
      height: 30px;
      color: #ffffff;
      background: #409EFF;
      padding: 0 12px;
      margin-left: 12px;
      border-radius: 2px;
      cursor: pointer;
    }

    img {
      height: 24px;
      position: absolute;
      left: 5px;
      top: 50%;
      margin-top: -12px;
      cursor: pointer;
    }

    input {
      border: none;
      background: #eeeeee;
      height: 30px;
      border-radius: 15px;
      outline: none;
      padding: 0 24px 0 34px;
      width: 600px;
    }


    // button {
    //   border: #cccccc solid 2px;
    //   padding: 0 12px;
    //   border-left: none;
    // }
  }

  .fen_ye {
    margin-top: 48px;
  }


  .title1 {
    font-size: 14px;
    margin-bottom: 36px;
    font-weight: 400;
    color: #86909c;
    line-height: 22px;
  }

  .title {
    font-size: 30px;
    margin-bottom: 4px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }
}
</style>
